import React, { useState, useRef, useEffect } from "react";
import emailjs from "emailjs-com";

function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_evyszx1",
        "template_t08wqbi",
        form.current,
        "OBeXpfCyQV-DCA79P"
      )
      .then(
        () => {
          form.current.reset();
          setIsOpen(false);
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
        },
        () => {
          alert("❌ Failed to send message. Please try again later.");
        }
      );
  };

  // close form when user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const formBox = document.getElementById("floatingContactBox");
      if (isOpen && formBox && !formBox.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <>
      {/* Floating Button */}
      <button
        className="btn btn-danger position-fixed shadow-lg d-flex align-items-center justify-content-center"
        style={{
          top: "50%",
          right: "-20px",
          transform: "translateY(-50%) Rotate(-90deg)",
          padding: "10px 16px",
          borderRadius: "10px 10px 0 0",
          zIndex: 9999,
        }}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle contact form"
      >
        <i className="bi bi-envelope-fill me-2 fs-5"></i> Contact Now
      </button>

      {/* Floating Contact Form */}
      {isOpen && (
        <div
          id="floatingContactBox"
          className="position-fixed bg-white border rounded-4 shadow-lg p-4"
          style={{
            top: "50%",
            right: "130px",
            transform: "translateY(-50%)",
            width: "340px",
            zIndex: 9999,
            animation: "slideInRight 0.4s ease-out",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold text-danger mb-0">Get in Touch</h5>
            <button
              className="btn-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close"
            ></button>
          </div>

          <form ref={form} onSubmit={sendEmail}>
            <div className="mb-2">
              <input
                type="text"
                name="user_name"
                className="form-control"
                placeholder="Your Name"
                pattern="[A-Za-z]+(\\s[A-Za-z]+){0,2}$"
                title="Only letters allowed"
                required
              />
            </div>

            <div className="mb-2">
              <input
                type="email"
                name="user_email"
                className="form-control"
                placeholder="Your Email"
                required
              />
            </div>

            <div className="mb-2">
              <input
                type="tel"
                name="phone"
                className="form-control"
                placeholder="Your Mobile No."
                pattern="[0-9]{10}"
                title="Only 10 digits allowed"
                required
              />
            </div>

            <div className="mb-2">
              <select name="services" className="form-select" required>
                <option value="">Select Your Service</option>
                <option value="Commercial Cleaning">Commercial Cleaning</option>
                <option value="Housekeeping Manpower">Housekeeping Manpower</option>
                <option value="Security Guard Service">Security Guard Service</option>
                <option value="Private Security Service">Private Security Service</option>
                <option value="Pantry Boy Service">Pantry Boy Service</option>
                <option value="Assembly Line Manpower">Assembly Line Manpower</option>
              </select>
            </div>

            <div className="mb-2">
              <textarea
                name="message"
                className="form-control"
                rows="3"
                placeholder="Message"
                required
              ></textarea>
            </div>

            <div className="d-grid mt-3">
              <button type="submit" className="btn btn-danger">
                Send Message
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Toast Notification */}
      {showToast && (
        <div
          className="toast show align-items-center text-white bg-success border-0 position-fixed p-3"
          style={{
            bottom: "20px",
            right: "20px",
            zIndex: 99999,
            borderRadius: "10px",
          }}
        >
          <div className="d-flex">
            <div className="toast-body">
              ✅ Message sent successfully!
            </div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
            ></button>
          </div>
        </div>
      )}

      {/* Animation CSS */}
      <style>{`
        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translate(100px, -50%);
          }
          to {
            opacity: 1;
            transform: translate(0, -50%);
          }
        }
      `}</style>
    </>
  );
}

export default FloatingContact;
